import apiClient from "@/axiosConfig";
import { useUxStore } from "@/stores/uxStore";

const getUxStore = () => useUxStore();

export default {
  async getAll(search = null, page = 1, pageSize = 200) {
    try {
      getUxStore().startLoading();
      const params = { page, pageSize };
      if (search) params.search = search;
      return await apiClient.get("/customer", { params });
    } catch (error) {
      console.error("Error in CustomerService.getAll:", error);
      getUxStore().setError("Fehler beim Laden der Kunden.");
      throw error;
    } finally {
      getUxStore().stopLoading();
    }
  },

  async getById(id) {
    try {
      getUxStore().startLoading();
      return await apiClient.get(`/customer/${id}`);
    } catch (error) {
      console.error("Error in CustomerService.getById:", error);
      getUxStore().setError("Fehler beim Laden des Kunden.");
      throw error;
    } finally {
      getUxStore().stopLoading();
    }
  },

  async create(payload) {
    try {
      getUxStore().startLoading();
      return await apiClient.post("/customer", payload);
    } catch (error) {
      console.error("Error in CustomerService.create:", error);
      getUxStore().setError("Fehler beim Erstellen des Kunden.");
      throw error;
    } finally {
      getUxStore().stopLoading();
    }
  },

  async update(id, payload) {
    try {
      getUxStore().startLoading();
      return await apiClient.put(`/customer/${id}`, payload);
    } catch (error) {
      console.error("Error in CustomerService.update:", error);
      getUxStore().setError("Fehler beim Aktualisieren des Kunden.");
      throw error;
    } finally {
      getUxStore().stopLoading();
    }
  },

  async remove(id) {
    try {
      getUxStore().startLoading();
      return await apiClient.delete(`/customer/${id}`);
    } catch (error) {
      console.error("Error in CustomerService.remove:", error);
      getUxStore().setError("Fehler beim Löschen des Kunden.");
      throw error;
    } finally {
      getUxStore().stopLoading();
    }
  },

  async export(format = "json") {
    try {
      getUxStore().startLoading();
      return await apiClient.post(`/customer/export?format=${encodeURIComponent(format)}`);
    } catch (error) {
      console.error("Error in CustomerService.export:", error);
      getUxStore().setError("Fehler beim Export der Kunden.");
      throw error;
    } finally {
      getUxStore().stopLoading();
    }
  },

  async import(fileId, upsert = true) {
    try {
      getUxStore().startLoading();
      return await apiClient.post("/customer/import", { fileId, upsert });
    } catch (error) {
      console.error("Error in CustomerService.import:", error);
      getUxStore().setError("Fehler beim Import der Kunden.");
      throw error;
    } finally {
      getUxStore().stopLoading();
    }
  },
};
